import { MIN_DISH_IMAGE_SIZE } from './eventFormConstants';
import { getImageDimensions, validateSquareImageMinDimensions } from './imageDimensionValidation';

const ALLOWED_DISH_IMAGE_MIME_TYPES = new Set(['image/png', 'image/jpeg']);

export const isDishImageFileAllowed = (file) => {
  if (!(file instanceof File)) return false;
  if (ALLOWED_DISH_IMAGE_MIME_TYPES.has(file.type)) return true;
  return /\.(png|jpe?g)$/i.test(file.name);
};

export const validateDishImageType = (file) => {
  if (!(file instanceof File)) {
    return { valid: true };
  }

  if (!isDishImageFileAllowed(file)) {
    return {
      valid: false,
      message: 'Dish image must be PNG, JPG or JPEG.',
    };
  }

  return { valid: true };
};

export const validateDishImageDimensions = (width, height) =>
  validateSquareImageMinDimensions(width, height, MIN_DISH_IMAGE_SIZE);

export const validateDishImageFile = async (file) => {
  if (!(file instanceof File)) {
    return { valid: true };
  }

  const typeResult = validateDishImageType(file);
  if (!typeResult.valid) {
    return typeResult;
  }

  try {
    const { width, height } = await getImageDimensions(file);
    return validateDishImageDimensions(width, height);
  } catch {
    return {
      valid: false,
      message: 'Unable to read dish image. Please try another file.',
    };
  }
};
